<template>
  <div :class="[css.wrapperClass]">
    <a
      :class="[css.linkClass, {[css.disabledClass] : isOnFirstPage}]"
      @click="loadPage(tablePagination.prev)"
    >
      <i :class="css.icons.prev"/>
    </a>
    <button
      :class="['vuetable-pagination-dropdown', css.dropdownClass]"
      data-toggle="dropdown"
      aria-expanded="false"
      @change="loadPage($event.target.selectedIndex+1)"
    >
      {{ pageText }} {{ tablePagination.current_page }}
      <span class="caret"/>
    </button>
    <ul :class="[css.pageClass]">
      <li
        v-for="n in totalPage"
        :value="n"
        :selected="isCurrentPage(n)"
        :key="n"
      >
        <a @click="loadPage(n)">{{ pageText }} {{ n }}</a>
      </li>
    </ul>
    <a
      :class="[css.linkClass, {[css.disabledClass] : isOnLastPage}]"
      @click="loadPage(tablePagination.next)"
    >
      <i :class="css.icons.next"/>
    </a>
  </div>
</template>

<script>
import PaginationMixin from "./VuetablePaginationMixinCustom.vue";

export default {
  mixins: [PaginationMixin],
  props: {
    pageText: {
      type: String,
      default() {
        return "Page";
      }
    }
  },
  created() {
    this.registerEvents();
  },
  methods: {
    registerEvents() {
      let self = this;

      this.$on("vuetable:pagination-data", tablePagination => {
        self.setPaginationData(tablePagination);
      });
    }
  },
};
</script>
